import {
    STALE_TIME_RESOURCES,
    queryClient,
} from "@impero-com/common/utils/query_client";

import {
    getGetTestingProgramsTestingProgramIdQueryOptions,
    useGetTestingProgramsTestingProgramIdSuspense,
} from "api/generated/testing-programs/testing-programs";

export function useTestingProgramQuery(testingProgramId: number) {
    return useGetTestingProgramsTestingProgramIdSuspense(testingProgramId, {
        query: {
            select: (response) => response.data,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}

export function fetchTestingProgramQuery(testingProgramId: number) {
    return queryClient
        .fetchQuery(
            getGetTestingProgramsTestingProgramIdQueryOptions(testingProgramId)
        )
        .then((response) => response.data);
}
